import { render, staticRenderFns } from "./dashboard-sale-instant-card.vue?vue&type=template&id=146223ee&scoped=true&"
import script from "./dashboard-sale-instant-card.vue?vue&type=script&lang=js&"
export * from "./dashboard-sale-instant-card.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-sale-instant-card.vue?vue&type=style&index=0&id=146223ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146223ee",
  null
  
)

export default component.exports